var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPresent = function SvgPresent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5334 0.199865C11.2734 -0.0601352 10.8534 -0.0601352 10.5934 0.199865L6.83342 3.95986L7.77342 4.89986L11.5334 1.1332C11.7868 0.879864 11.7868 0.453198 11.5334 0.199865ZM14.3601 0.193198L7.77342 6.77986L5.45342 4.46653C5.19342 4.20653 4.77342 4.20653 4.51342 4.46653C4.25342 4.72653 4.25342 5.14653 4.51342 5.40653L7.30009 8.1932C7.56009 8.4532 7.98009 8.4532 8.24009 8.1932L15.3001 1.13986C15.5601 0.879865 15.5601 0.459865 15.3001 0.199865H15.2934C15.0401 -0.0668019 14.6201 -0.066802 14.3601 0.193198ZM0.746758 5.4132L3.53342 8.19986C3.79342 8.45986 4.21342 8.45986 4.47342 8.19986L4.94009 7.7332L1.68676 4.46653C1.42676 4.20653 1.00676 4.20653 0.746758 4.46653C0.486758 4.72653 0.486758 5.1532 0.746758 5.4132Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPresent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/present.6c534fd7.svg";
export { ForwardRef as ReactComponent };